<template>
  <main class="campaign-action-bar">
    <modal
      v-if="showImagePreview"
      @close="cancelImageUpload"
      :showClose="true"
      class="image-preview-modal"
    >
      <h3 slot="header" class="title">include this image?</h3>
      <div slot="body" class="image-preview">
        <img v-if="pendingImage" :src="pendingImage.url" class="image" />
        <img v-else :src="attachmentPreview" class="image" />
      </div>
      <div slot="action" class="action-wrapper">
        <button @click="includeImage" class="upload-image button larger" data-cy="include-image-button">include this image</button>
      </div>
    </modal>

    <section class="action-tabs-container border-can-error" :class="{ expanded: openedActions.length > 0 }" v-has-error:sms_content>
      <div class="action-tab emoji-tab" @click="clickedTab('emojis')" data-cy="action-emoji-tab" :class="{ opened: openedActions.includes('emojis') }">
        <fai :icon="['far', 'smile-beam']" size="1x" />
        emoji
      </div>

      <div class="action-tab swap-tab" @click="clickedTab('substitutions')" data-cy="action-substitution-tab" :class="{ opened: openedActions.includes('substitutions') }">
        <fai :icon="['fas', 'exchange']" size="1x" />
        substitution
      </div>
    </section>

    <section class="action-container" :class="{ expanded: openedActions.length > 0 }">
      <section class="emojis action-bar-item" :class="{ opened:openedActions.includes('emojis') }">
        <div class="action-bar-content">
          <emoji-grid
            @updated:emoji="updatedEmoji"
          ></emoji-grid>

          <div class="close-container">
            <div class="close-btn" @click="clickedClose('emojis')" data-cy="emoji-close-button">
              close
            </div>
          </div>
        </div>
      </section>

      <section class="substitutions action-bar-item" :class="{ opened:openedActions.includes('substitutions') }">
        <div class="action-bar-content">
          <substitutions
            :substitutions="substitutions"
            @updated:substitution="updatedSubstitution"
          ></substitutions>

          <div class="close-btn" @click="clickedClose('substitutions')" data-cy="substitution-close-button">
            close
          </div>
        </div>
      </section>
    </section>
  </main>
</template>

<script>
import {mapGetters} from "vuex";
import { attachmentAPI } from "../../../services/api/attachmentAPI";
import Substitutions from "./substitutions";
import EmojiGrid from "./emoji-grid";
import ImageGrid from "./image-grid";
import ImageAttachment from "./image-attachment";
import Modal from '../../shared/Modal';
import { HasError } from "@springbig/sb-components";

export default {
  name: "campaign-action-bar",

  directives: {
    HasError
  },

  components: {
    Substitutions,
    EmojiGrid,
    ImageGrid,
    ImageAttachment,
    Modal
  },

  props: {
    campaign: Object,
    ownerType: String,
  },

  data() {
    return {
      showImagePreview: false,
      isLoading: false,
      pendingImage: null,
      uploadedImage: null,
      openedActions: [],
      storedImages: [],
      substitutions: [
        { label: 'customer first name', tag: 'MEMBER_FIRST_NAME' },
        { label: 'customer points balance', tag: 'MEMBER_BALANCE' },
        { label: 'date of point expiration', tag: 'EXPIRATION_DATE' },
        { label: 'expiring points', tag: 'EXPIRATION_POINTS' },
      ]
    };
  },

  async created() {
    const attachments = await attachmentAPI.forCampaign(this.campaign.id, { label: ['mms'] });
    if(this.ownerType != 'AutoCampaignMessage') {
      const attachments = await attachmentAPI.forCampaign(this.campaign.id, { label: ['mms'] });
      this.uploadedImage = attachments[0];
    }
  },

  methods: {
    async clickedRemove() {
      this.isLoading = true;
      const resp = await attachmentAPI.delete(this.uploadedImage.uuid)
      if(resp.success) {
        this.uploadedImage = null;
        await this.refreshStoredImages();
      } else {
        // TODO: Handle failed delete
      }
      this.isLoading = false;
    },

    clickedClose(tab) {
      this.openedActions = this.openedActions.filter((openedTab) => openedTab !== tab);
    },

    clickedTab(tab) {
      this.openedActions.push(tab);
    },

    updatedEmoji(item) {
      this.$emit('shouldInsertText', item.emoji);
    },

    updatedSubstitution(sub) {
      this.$emit('shouldInsertText', `%{${sub.tag}}`);
    }
  },

  computed: {
    attachmentPreview() {
      return this.uploadedImage?.thumb;
    },

    ...mapGetters(['classicCampaignsEnabled'])
  }
}
</script>

<style scoped>
.campaign-action-bar {
  display: flex;
  flex-direction: column;
}

.action-container.expanded {
  border-right: 1px solid #A6D4FC;
  border-left: 1px solid #A6D4FC;
  border-bottom: 1px solid #A6D4FC;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  overflow: hidden;
}

.action-bar-item {
  border-top: none;
  overflow: hidden;
  transition: max-height 0.7s ease, border 0.7s ease;
  max-height: 0;
}

.action-tabs-container {
  display: flex;
  align-items: center;
}

.action-tabs-container {
  border-right: 1px solid #A6D4FC;
  border-left: 1px solid #A6D4FC;
  border-bottom: 1px solid #A6D4FC;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}

.action-tabs-container.expanded {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.remove-btn {
  margin: 5px 0;
  text-align: center;
  cursor: pointer;
}

.close-btn {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  width: 80px;
  padding: 0 1.5em;
  background-color: rgba(18, 143, 249, 0.15);
  cursor: pointer;
  color: #5e6469;
  font-size: .9em;
  font-weight: bold;
}

.close-container {
  background-color: rgba(18, 143, 249, 0.15);
}

.close-container .close-btn {
  background-color: rgba(18, 143, 249, 0.15);
}

.manage-attachments {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding-top: 4px;
}

.attach-image {
  max-width: 125px;
  color: rgb(74, 74, 74);
}

.action-tab {
  transition: all 0.75s ease;
  background-color: #128ff9;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  cursor: pointer;
  color: white;
  display: flex;
  flex-direction: column;
  font-size: 18px;
  align-items: center;
  padding: 5px 15px;
  min-width: 105px;
}

.action-tab.opened {
  opacity: 0;
}

.action-bar-item.opened {
  max-height: 300px;
}

.loading-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px
}

.campaign-action-bar.invalid-text .action-tabs-container {
  border-color: #f91253;
}

.mms-tab {
  position: relative;
}

.mms-tab .counter {
  position: absolute;
  color: white;
  background-color: #f91253;
  top: -6px;
  right: -3px;
  font-size: 12px;
  font-weight: bold;
  line-height: 8px;
  padding: 5px;
  border-radius: 10px;
}

.emoji-tab {
  border-bottom-left-radius: 15px;
}
</style>
